// Dispatches by hostname so image transforms happen at the CDN edge rather
// than via Next's /_next/image endpoint. Drops the sharp runtime dependency
// entirely and pushes CPU cost to the upstream CDN.

type LoaderArgs = {
  src: string;
  width: number;
  quality?: number;
};

export default function imageLoader({ src, width, quality }: LoaderArgs): string {
  const q = quality ?? 75;

  if (src.startsWith('https://images.ctfassets.net/')) {
    // https://www.contentful.com/developers/docs/references/images-api/
    return withQuery(src, { w: String(width), fm: 'avif', q: String(q) });
  }

  // Phase 2: width-to-preset mapping for the Opendoor images worker. Until the
  // OpendoorImage wrapper lands, pass through so URLs already carrying
  // ?preset=... continue to work.
  return src;
}

function withQuery(src: string, params: Record<string, string>): string {
  const url = new URL(src);
  for (const [k, v] of Object.entries(params)) {
    url.searchParams.set(k, v);
  }
  return url.toString();
}
